export default __webpack_public_path__ + "static/rovo-overlay-remix-dark-4559af4494080b703ce1def51d6d4ae486f6e398c83e8ce58c6fff03164e5e73.png";